angular.module('dpw.components')
    .component('dpwProductFilter', {
        bindings: {
            isPanelVisible: '<'
        },
        templateUrl: 'dpw-product-filter.html',
        controller: ['productFilterService', 'contentfulService', '$element', '$timeout', function (productFilterService, contentfulService, $element, $timeout) {
            var self = this;
            self.languageKeysForRegions = {};

            self.$onInit = function () {
                productFilterService.init();

                contentfulService.getSiteWide().then(function (texts) {
                    var languageKeys = _.get(texts, 'languageKeys');
                    self.languageKeysForRegions = _.get(languageKeys, 'regions', {});
                });
            };

            self.$onChanges = function (changesObj) {
                var visiblePrevious = _.get(changesObj, 'isPanelVisible.previousValue');
                var visibleCurrent = _.get(changesObj, 'isPanelVisible.currentValue');

                if (visibleCurrent !== visiblePrevious && !visibleCurrent) {
                    self.closePartnerFilterDropdown();
                }
            };

            self.closePartnerFilterDropdown = function () {
                var $el = $element.find('.partner-filter-drop-down-list');

                if ($el && $el.length > 0) {
                    $el.hide();

                    $timeout(function () {
                        $el.show();
                    });
                }
            };

            Object.defineProperties(self, {
                productFamilyItems: {
                    get: function () {
                        return productFilterService.getProductFamilyOptions();
                    }
                },
                regionItems: {
                    get: function () {
                        return productFilterService.getRegionOptions();
                    }
                },
                partnerItems: {
                    get: function () {
                        return productFilterService.getPartnerOptions();
                    }
                },
                selectedPartner: {
                    get: function () {
                        return productFilterService.getSelectedPartner();
                    },
                    set: function (value) {
                        productFilterService.updateFilterState({
                            partner: value
                        });
                    }
                }
            });

            self.isProductFamilyActive = function (item) {
                return productFilterService.getSelectedProductFamily() === item;
            };

            self.onSelectProductFamily = function (item) {
                productFilterService.updateFilterState({
                    productFamily: item
                });
            };

            self.onSelectedRegionsChanged = function () {
                var regionsSelected = self.regionItems
                    .filter(function (item) {
                        return item.checked;
                    })
                    .map(function (item) {
                        return item.label;
                    });

                productFilterService.updateFilterState({
                    regions: regionsSelected
                });
            };

            self.getRegionFullName = function (regionId) {
                return self.languageKeysForRegions[regionId] || regionId;
            };
        }]
    });
